import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cpl-event',
  templateUrl: './cpl-event.component.html',
  styleUrl: './cpl-event.component.css'
})
export class CplEventComponent {
  @Input() taskTitle: string;
  @Input() taskDescription: string;
  @Input() taskStart: string;
  @Input() taskEnd: string;
  @Input() taskState: string;
  @Input() canEdit: boolean = true;
  @Output() eventAction = new EventEmitter<boolean>();

  getDuration(start: string | Date, end: string | Date): string {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMs = endDate.getTime() - startDate.getTime();

    if (diffMs < 0) return 'Invalid range';

    const diffMinutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    return `${hours}h ${minutes}m`;
  }
}
